import React, { Component } from 'react';
import PropTypes from 'prop-types';

//  Non trasformare in pure function
/* eslint-disable react/prefer-stateless-function */
class Divider extends Component {
  render() {
    const {
      children,
      notifica,
      additionalData,
      isSelected,
      ...others
    } = this.props;

    return (
      <li
        className="select__divider"
        {...others}
      >
        {children}
      </li>
    );
  }
}

Divider.defaultProps = {
  additionalData: null,
  children: null,
  isSelected: false,
  notifica: null,
};

Divider.propTypes = {
  /**
     * @ignore
     */
  additionalData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
     * @ignore
     */
  isSelected: PropTypes.bool,
  /**
     * @ignore
     */
  notifica: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

export default Divider;
